<template>
  <a class="banner" target="_blank" :href="$t(`banner.${name}.url`)" rel="noopener noreferrer">
    <img class="banner-image" :src="$t(`banner.${name}.src`)" alt="banner" />
  </a>
</template>

<script>
export default {
  props: {
    name: { type: String, default: 'default' },
  },
};
</script>
